import fields from './fields';
import validations from './validations';

export default {
  ...fields,
  ...validations,
  sender_name: '发送者姓名',
  sender_wallet: '发送者钱包',
  last_n_digits: '交易参考号',
  invoice_flow__multi_time_remainin: '剩余时间',
  invoice_flow__multi_or: '或',
  invoice_flow__multi_open_app: '在应用中打开',
  invoice_flow__multi_return_button: '返回网站',
  invoice_flow__card_transfer_button: '确认',
  invoice_flow__multi_upi_qr_step_1: '扫描或复制上方二维码',
  invoice_flow__multi_upi_qr_step_2: '请完成支付',
  invoice_flow__multi_step_3: '填写 <b>{attributes}</b> 后点击“确认”按钮',
  invoice_flow__multi_upi_qr_mob_step_1: '扫描上方二维码，或点击“在应用中打开”按钮',
  invoice_flow__multi_bank_transfer_step_1: '复制收款信息',
  invoice_flow__multi_bank_transfer_step_2: '请完成支付',
  invoice_flow__card_transfer_step_1: '复制收款信息',
  invoice_flow__card_transfer_step_2:
    '请转账指定金额（可使用您的银行账户，或前往最近的银行或自助终端）',
  invoice_flow__card_transfer_step_3: '填写确认信息：<b>{attributes}</b>',
  invoice_flow__card_transfer_step_4: '转账完成后，点击 <b>“确认”</b>',
};
